import apiInstance from "api";

export const AdminQuotationApiService = {
  createQuotation: async (body) => {
    return await apiInstance.post("/admin/quotations", body);
  },
  getQuotations: async (filters) => {
    return await apiInstance.get("/admin/quotations", {
      params: {
        ...filters,
      },
    });
  },
  getQuotation: async (quotationId) => {
    return await apiInstance.get(`/admin/quotations/${quotationId}`);
  },
  updateQuotation: async (quotationId, body) => {
    return await apiInstance.put(`/admin/quotations/${quotationId}`, body);
  },
  // body is optional: { userProfileId?, email?, message? }. Without it the
  // quote goes to the customer contact recorded on it.
  sendQuotation: async (quotationId, body = {}) => {
    return await apiInstance.post(`/admin/quotations/${quotationId}/send`, body);
  },
  getRecipients: async (quotationId) => {
    return await apiInstance.get(`/admin/quotations/${quotationId}/recipients`);
  },
  // Bills the quote: raises the invoice (or reuses the draft already linked to
  // it), emails it, and moves it to Open so it lands on the customer's
  // /payables. Recipients come from getRecipients above — same contact list the
  // quote send dialog uses, since the invoice bills the same organisation.
  // body: { userProfileId?, email?, message?, attachPdf?, embedPayOnline?,
  //         vendorInvoiceNumber?, dueDate?, amount?, items? }
  sendInvoice: async (quotationId, body = {}) => {
    return await apiInstance.post(`/admin/quotations/${quotationId}/send-invoice`, body);
  },
  getQuotationPdf: async (quotationId) => {
    return await apiInstance.get(`/admin/quotations/${quotationId}/pdf`, {
      responseType: "blob",
    });
  },
  deleteQuotation: async (quotationId) => {
    return await apiInstance.delete(`/admin/quotations/${quotationId}`);
  },
  confirmPayment: async (quotationId, body) => {
    return await apiInstance.post(`/admin/quotations/${quotationId}/confirm-payment`, body);
  },
};
